import { Component, Input, OnInit } from '@angular/core'
import { SafeHtml } from '@angular/platform-browser'
import { BlockDataService } from 'src/app/block-services/block-data.service'
import { BlockFieldsService } from 'src/app/block-services/block-fields.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { PagesService } from 'src/app/pages/website-builder/pages.service'
import { AppSettingsService } from 'src/app/settings/services/app-settings.service'
import { IconsSelectorComponent } from 'src/app/pages/icons-selector/icons-selector.component'
import { MatDialog } from '@angular/material/dialog'
import { ProductsService } from '../block-products/products.service'
import { ProductsService as standaloneProductsService } from '../../e-commerce/products/products.service'
import { CategoriesService as standaloneCategoriesService } from '../../e-commerce/categories/categories.service'
import { CategoriesService } from '../block-categories/categories.service'
import { PostsService } from '../block-posts/posts.service'
import { LoginService } from 'src/app/login/login.service'
import { StorageService } from '../../e-commerce/orders/storage-service/storage.service'
import { FooterTemplateService } from 'src/app/footer-website-templates/footer-template.service'
import { footerTemplatesStyle } from 'src/app/footer-website-templates/footer-template-styles'
import { FloatingSocialService } from '../block-floating-social/floating-social.service'

@Component({
  selector: 'block-footer',
  templateUrl: './block-footer.component.html',
  styleUrls: ['./block-footer.component.scss']
})
export class BlockFooterComponent implements OnInit {
  footerTemplate: any;
  previewBlock = true
  styleFields = false
  blockData: any

  previewFields = false

  blockHeaderSrc = ''
  blockHeaderBg = ''
  blockFields: any
  blockFieldsCustomPage: any

  blockId = ''

  showProgress = false

  toggleChecked = false

  storedCategories: any = []
  storedPosts: any = []
  storedProducts: any = []
  storedStandaloneProducts: any = []
  storedStandaloneCategories: any = []
  postTypes: any = []
  rejectedTypes: any = ['attachment', 'nav_menu_item', 'page', 'product', 'wp_block', 'wp_navigation', 'wp_template', 'wp_template_part']
  currentYear = new Date().getFullYear()
  availablePages: any[] = []

  @Input() importedBlockData: any
  private _builderType: 'mobile' | 'website' = 'mobile'
  @Input()
  set builderType(value: 'mobile' | 'website') {
    this._builderType = value
  }
  get builderType(): 'mobile' | 'website' {
    // Auto-detect based on builderService context if not explicitly set
    if (this.builderService && this.builderService.headerBtn === 'websitePageEditor') {
      return 'website'
    }
    return this._builderType
  }

  get socialPlatforms() {
    return this.floatingSocialService.socialPlatforms
  }

  constructor(
    public blockDataService: BlockDataService,
    public blockFieldsService: BlockFieldsService,
    public builderService: BuilderService,
    private pagesService: PagesService,
    private appSettingsService: AppSettingsService,
    public dialog: MatDialog,
    private productsService: ProductsService,
    public standaloneProductsService: standaloneProductsService,
    public categoriesService: CategoriesService,
    public standaloneCategoriesService: standaloneCategoriesService,
    private postsService: PostsService,
    public loginService: LoginService,
    private storageService: StorageService,
    private footerTemplateService: FooterTemplateService,
    public floatingSocialService: FloatingSocialService
  ) {
    // Load available pages for website builder footer links
    if (this.builderService.selectedProject) {
      this.pagesService.getPages(this.builderService.selectedProject).subscribe((pages: any) => {
        if (pages) {
          this.availablePages = Object.values(pages).map((value: any) => ({
            id: (value as any).page_id,
            name: (value as any).page_name,
            title: (value as any).title
          }))
        }
      })
    }
  }

  ngOnInit() {
    // Set blockId from imported data if available BEFORE subscribing
    if (this.importedBlockData && this.importedBlockData.id) {
      this.blockId = this.importedBlockData.id
    } else if (!this.blockId) {
      // For website builder, always use consistent 'static-footer' ID
      if (this.builderType === 'website') {
        this.blockId = 'static-footer'
      } else {
        this.blockId = this.blockDataService.getUniqueId(2)
      }
    }

    // For website builder, load from static blocks
    if (this.builderType === 'website' && this.builderService.selectedProject) {
      this.loadStaticFooter()
      return
    }

    // For mobile builder, use existing global footer logic
    this.blockDataService.getGlobalFooter().subscribe(() => {
      if (!this.blockId) {
        this.blockId = this.blockDataService.getUniqueId(2)
      }
      this.blockFields = this.getBlockFields(this.blockId)
      this.blockFieldsCustomPage = this.getBlockFieldsCustomPage(this.blockId)
      if (this.importedBlockData) {
        this.previewBlock = true
        this.previewFields = false
        this.styleFields = false
      }
      // if(this.builderService.globals || this.blockFieldsService.readGlobalFooter) {
      //   this.blockData = this.builderService.globalFooter;
      // } else {
      //   this.blockData = this.importedBlockData ? this.importedBlockData : this.blockFieldsService.getFooterBlockFields();
      // }
      let footerBlockData = this.blockDataService.getAllBlocksData()[this.blockDataService.getAllBlocksData().length - 1]
      // this.blockHeaderSrc = this.blockData.data?.src;

      // let footerBlockData = this.blockDataService.getSelectedBlockData(this.blockId);
      if (footerBlockData && footerBlockData.data.global_footer == undefined) {
        footerBlockData.data.global_footer = true
      }

      if (this.builderService.globals || footerBlockData?.data?.global_footer || footerBlockData?.data?.global_footer == undefined) {
        this.blockData = this.builderService.globalFooter
        footerBlockData = this.builderService.globalFooter ? this.builderService.globalFooter : {}
        this.blockFieldsService.readGlobalFooter = true
        if (footerBlockData && footerBlockData.data) {
          footerBlockData.data.global_footer = true
        } else {
          footerBlockData.data = {
            global_footer: true
          }
        }

        // console.log("Read from Global Footer", footerBlockData);
      } else {
        this.blockData = this.importedBlockData ? this.importedBlockData : this.blockFieldsService.getFooterBlockFields()
        footerBlockData = this.blockFieldsCustomPage
        this.blockFieldsService.readGlobalFooter = footerBlockData.data?.global_footer == undefined ? true : footerBlockData.data?.global_footer
        // console.log("Read from Local Footer");
      }

      this.toggleChecked = footerBlockData.data?.type == 'icon' ? true : false
      this.blockFieldsService.readGlobalFooter = footerBlockData.data?.global_footer == undefined ? true : footerBlockData.data?.global_footer

      console.log(footerBlockData.data?.footerStyle)
      if (footerBlockData.data && !footerBlockData.data.footerStyle) {
        footerBlockData.data.footerStyle = 'classic'
      }
      if (this.categoriesService.storedCategories.length == 0) {
        this.getCategories(this.builderService.getSelectedProject(), this.blockFieldsService.categoriesBlockData.data, true)
      }

      this.getPosts(this.builderService.getSelectedProject(), this.blockFieldsService.postsBlockData.data, true)

      this.getProducts(this.builderService.getSelectedProject(), this.blockFieldsService.productsBlockData.data, true)
      // this.standaloneProductsService.getStandaloneProducts();
      this.getStandaloneCategories()
      // this.toggleChanged(this.blockId, 'global_footer');

      // if( this.builderService.globals ) {
      //   let footerBlockFields = this.blockDataService.getSelectedBlockData(this.blockId);
      //   this.builderService.globalFooter = footerBlockFields;
      // }

      let gAdMob = footerBlockData.data?.gFooterBanners
      if (gAdMob) {
        let gAdmobFooterFlag = false
        for (const key in gAdMob) {
          if (Object.prototype.hasOwnProperty.call(gAdMob, key)) {
            const element = gAdMob[key]
            // console.log(element);
            if (element.status == 'active') {
              gAdmobFooterFlag = true
            }
          }
        }
        this.blockDataService.gAdMobActiveFooter = gAdmobFooterFlag
      }

      /**
       * Get Post Types and load the variables
       */
      this.getPostTypes()

      // Call getStandaloneProducts for mobile builder
      this.standaloneProductsService.getStandaloneProducts()
      if (this.getBlockFields(this.blockId).data?.categories) {
        this.getCat({ value: this.getBlockFields(this.blockId).data.categories })
      }
    })
  }

  /**
   * Load static footer from Firebase for website builder
   */
  loadStaticFooter() {
    // Always use 'static-footer' ID for consistency
    this.blockId = 'static-footer'

    // Find the footer block in blocksData
    const footerBlock = this.blockDataService.blocksData.find((block: any) => block.type === 'footer')
    console.log('Searching for footer block in blocksData:', footerBlock)
    if (footerBlock) {
      // Normalize the footer block's ID to 'static-footer'
      footerBlock.id = 'static-footer'
      this.blockData = footerBlock
      this.blockFields = footerBlock

      // Initialize UI properties from loaded data
      if (footerBlock.data) {
        this.toggleChecked = footerBlock.data.type == 'color'
        // Apply template1 defaults if no template is set
        if (!footerBlock.data.footerTemplate) {
          const templateConfig = (footerTemplatesStyle as any)['template1']
          footerBlock.data.footerTemplate = 'template1'
          footerBlock.data.footerStyle = templateConfig?.footerStyle || 'classic'
          footerBlock.data.hasWave = templateConfig?.hasWave || false
          footerBlock.data.layout = footerBlock.data.layout || templateConfig?.layout
          footerBlock.data.styleVars = footerBlock.data.styleVars || templateConfig?.styleVars
          // Apply default colors if not set
          footerBlock.data.bgColor = footerBlock.data.bgColor || '#000000'
          footerBlock.data.textColor = footerBlock.data.textColor || '#ffffff'
        }
      }

      console.log('Loaded footer block from blocksData:', footerBlock)
    } else {

      // No footer block in blocksData, load from Firebase and create one
      this.pagesService.getStaticBlock(this.builderService.selectedProject, 'footer').subscribe((staticFooter: any) => {
        console.log('Fetched static footer from Firebase:', staticFooter,Object.keys(staticFooter).length )
        if (staticFooter && Object.keys(staticFooter).length > 0) {
          // Static footer exists, load it
          this.blockData = staticFooter
          this.blockFields = staticFooter

          // Initialize UI properties from loaded data
          if (staticFooter.data) {
            this.toggleChecked = staticFooter.data.type == 'color'
            if (!staticFooter.data.footerStyle) {
              staticFooter.data.footerStyle = 'classic'
            }
          }

          // Add the footer block to blocksData so it appears in the preview
          const footerBlock = {
            ...staticFooter,
            id: 'static-footer',
            type: 'footer'
          }
          this.blockDataService.blocksData.push(footerBlock)
          this.blockDataService.blocksData = [...this.blockDataService.blocksData]

          console.log('Static footer loaded from Firebase and added to blocksData:', staticFooter)
        } else {
          // No static footer exists, create default footer for website builder
          // Default: classic template1 with black bg and white text
          const templateConfig = (footerTemplatesStyle as any)['template1']
          const defaultFooterData = {
            id: 'static-footer',
            type: 'footer',
            data: {
              // Website-specific footer data structure
              description: 'Your trusted destination for quality products and exceptional service. We bring you the best selection at competitive prices.',
              productLinks: [
                { name: 'Products', url: '/products' },
                { name: 'Categories', url: '/categories' },
                { name: 'Home', url: '/home' }
              ],
              companyLinks: [
                { name: 'About', url: '/about' },
                { name: 'Contact', url: '/contact' },
                { name: 'Home', url: '/home' }
              ],
              showLogo: true,
              type: 'color',
              bgColor: '#000000',
              textColor: '#ffffff',
              // Apply classic template1 defaults
              footerTemplate: 'template1',
              footerStyle: templateConfig?.footerStyle || 'classic',
              hasWave: templateConfig?.hasWave || false,
              layout: templateConfig?.layout,
              styleVars: templateConfig?.styleVars
            },
            style: {}
          }

          this.blockData = defaultFooterData
          this.blockFields = defaultFooterData

          // Save the default footer to Firebase immediately
          this.pagesService.setStaticBlock(this.builderService.selectedProject, 'footer', defaultFooterData).subscribe(() => {
            console.log('Default static footer created and saved to Firebase')
          }, (error) => {
            console.error('Error saving default static footer:', error)
          })

          // Add the footer block to blocksData so it appears in the preview
          this.blockDataService.blocksData.push(defaultFooterData)
          this.blockDataService.blocksData = [...this.blockDataService.blocksData]

          console.log('No static footer found, created default footer for website')
        }
      })
    }
  }

  /**
   * Save static footer to Firebase for website builder
   */
  saveStaticFooter() {
    if (this.builderType !== 'website') return

    const footerData = this.getBlockFields(this.blockId)

    // Ensure footer data includes id and type for consistency with header
    const footerDataToSave = {
      ...footerData,
      id: this.blockId,
      type: 'footer'
    }

    // Update local blockData to trigger preview update
    this.blockData = { ...footerDataToSave }
    this.blockFields = { ...footerDataToSave }

    // Update the footer block in blocksData array for preview to pick up changes
    const footerIndex = this.blockDataService.blocksData.findIndex((block: any) => block.id === this.blockId)
    if (footerIndex !== -1) {
      // Create new object reference to trigger Angular change detection
      this.blockDataService.blocksData[footerIndex] = { ...footerDataToSave }
      // Create new array reference to ensure change detection
      this.blockDataService.blocksData = [...this.blockDataService.blocksData]
    }

    this.pagesService.setStaticBlock(this.builderService.selectedProject, 'footer', footerDataToSave).subscribe(() => {
      console.log('Static footer saved successfully')
    }, (error) => {
      console.error('Error saving static footer:', error)
    })
  }

  getPostTypes = () => {
    this.postsService.getPostTypes().subscribe(
      (response) => {
        let formattedResult: any = []
        for (const key in response) {
          const element = response[key].slug
          let index = this.rejectedTypes.indexOf(element)
          if (index !== -1) {
            delete response.element
          } else {
            formattedResult.push(element)
          }
        }
        this.postTypes = formattedResult
      },
      (err) => {}
    )
  }
  toggleChanged(blockId: any, type: string = 'background') {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    // let productsBlockFields = this.blockDataService.getSelectedBlockData(blockId);
    let productsBlockFields = this.getBlockFields(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...productsBlockFields.data }
    let clonedBlockFieldsStyle = { ...productsBlockFields.style }

    if (type == 'background') {
      clonedBlockFieldsData['type'] = this.toggleChecked ? 'color' : 'image'
    } else if (type == 'global_footer') {
      clonedBlockFieldsData['global_footer'] = this.blockFieldsService.readGlobalFooter ? true : false
      this.getBlockFieldsCustomPage(blockId).data.global_footer = clonedBlockFieldsData['global_footer']
      this.blockFields = this.getBlockFields(this.blockId)
    }

    productsBlockFields.data = clonedBlockFieldsData
    productsBlockFields.style = clonedBlockFieldsStyle
    if (this.builderService.globals) {
      this.builderService.globalFooter = productsBlockFields
    }

    // Save static footer for website builder
    if (this.builderType === 'website') {
      this.saveStaticFooter()
    }
  }
  /**
   * Appends Block to the Preview, Initial checks if the block is added as initial block addition or appended live
   */
  addBlockToPreview(initial: any = '') {
    let blockHeaderData = {
      component: BlockFooterComponent,
      index: 'latest',
      element: this,
      initial: initial
    }
    this.blockDataService.sendBlockData(blockHeaderData)
  }

  appendBlock() {
    let clonedBlockData = { ...this.blockData }
    this.blockId = this.blockDataService.appendBlocksData(clonedBlockData)
  }

  /**
   * Sync the clicked block on click inside the mobile preview
   */
  showData(blockId: any) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      // show data of the last element instead
      blockId = this.blockDataService.getLatestBlockId()
    }
    this.blockFieldsService.clickedBlockId = blockId
    this.blockDataService.sendCurrentBlock(BlockFooterComponent)
  }

  queryChange(query: any, blockId: any, $event: any, type: string, index: number, dataType: string = 'menuItems') {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let productsBlockFields = this.getBlockFields(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...productsBlockFields.data }
    let data: any = ''
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value
    } else if (type == 'slider') {
      data = $event.currentTarget.value
    } else if (type == 'multilevelText') {
      data = $event.currentTarget.value
    } else if (type == 'multilevelSelect') {
      data = $event.value
    } else if (type == 'toggle') {
      data = $event.checked
    }

    if (type == 'multilevelText' || type == 'multilevelSelect') {
      clonedBlockFieldsData[dataType][index][query] = data
    } else if (query.endsWith('Url') && ['facebookUrl', 'instagramUrl', 'linkedinUrl', 'twitterUrl', 'tiktokUrl'].includes(query)) {
      // Handle social media URLs - store them in a nested socialMedia object
      if (!clonedBlockFieldsData.socialMedia) {
        clonedBlockFieldsData.socialMedia = {}
      }
      clonedBlockFieldsData.socialMedia[query] = data
    } else {
      clonedBlockFieldsData[query] = data
    }
    productsBlockFields.data = clonedBlockFieldsData
    // console.log(productsBlockFields.data);
    // this.builderService.globalFooter = productsBlockFields;
    let gAdMob = productsBlockFields.data.gFooterBanners
    if (gAdMob) {
      let gAdmobFooterFlag = false
      for (const key in gAdMob) {
        if (Object.prototype.hasOwnProperty.call(gAdMob, key)) {
          const element = gAdMob[key]
          if (element.status == 'active') {
            gAdmobFooterFlag = true
          }
        }
      }
      this.blockDataService.gAdMobActiveFooter = gAdmobFooterFlag
    }
    if (query == 'post_type') {
      this.blockFieldsService.postsBlockData.data.post_type = data
      this.getPosts(this.builderService.selectedProject, this.blockFieldsService.postsBlockData.data, false)
    }

    if (data == 'posts') {
      this.getPosts(this.builderService.getSelectedProject(), clonedBlockFieldsData, false)
    }

    if (data == 'products' && !this.builderService.standalone) {
      this.getProducts(this.builderService.getSelectedProject(), clonedBlockFieldsData, false)
    }
    if (data == 'products' && this.builderService.standalone) {
      this.standaloneProductsService.getStandaloneProducts()
    }
    if (data == 'productsCategories' && this.builderService.standalone) {
      this.getStandaloneCategories()
    }

    // Save static footer for website builder
    if (this.builderType === 'website') {
      this.saveStaticFooter()
    }
  }

  processFile(fileInput: any, type: string, name: string, blockId: string) {
    const file: File = fileInput.target.files[0]

    if (!file) {
      return
    }

    this.showProgress = true

    // Handle footer logo upload to Supabase Storage (same path as header logo)
    if (name === 'footerLogo') {
      const projectId = this.builderService.selectedProject
      const fileExtension = file.name.split('.').pop()
      const storagePath = `images/footer_logo.${fileExtension}`

      this.storageService.uploadFile(file, projectId, storagePath).then(
        (downloadURL) => {
          this.showProgress = false
          let imgBlockFields = this.getBlockFields(blockId)
          let clonedBlockFieldsData = { ...imgBlockFields.data }

          clonedBlockFieldsData.footerLogoUrl = downloadURL
          imgBlockFields.data = clonedBlockFieldsData

          // Save to static footer for website builder
          if (this.builderType === 'website') {
            this.saveStaticFooter()
          }

          console.log('Footer logo uploaded to Supabase Storage:', storagePath)
        },
        (err) => {
          this.showProgress = false
          console.error('Error uploading footer logo:', err)
          alert('Error uploading footer logo. Please try again.')
        }
      )
    } else if (name === 'footerBgImage') {
      // Handle footer background image upload to Supabase Storage
      const projectId = this.builderService.selectedProject
      const fileExtension = file.name.split('.').pop()
      const storagePath = `images/footer_bg_image.${fileExtension}`

      this.storageService.uploadFile(file, projectId, storagePath).then(
        (downloadURL) => {
          this.showProgress = false
          let imgBlockFields = this.getBlockFields(blockId)
          let clonedBlockFieldsData = { ...imgBlockFields.data }

          clonedBlockFieldsData.footerBgImageUrl = downloadURL
          imgBlockFields.data = clonedBlockFieldsData

          // Save to static footer for website builder
          if (this.builderType === 'website') {
            this.saveStaticFooter()
          }

          console.log('Footer background image uploaded to Supabase Storage:', storagePath)
        },
        (err) => {
          this.showProgress = false
          console.error('Error uploading footer background image:', err)
          alert('Error uploading footer background image. Please try again.')
        }
      )
    } else {
      // Use existing upload service for other file types
      const reader = new FileReader()
      reader.addEventListener('load', (event: any) => {
        this.builderService.uploadFileCustomerServer(file, this.builderService.selectedProject, type).subscribe(
          (res) => {
            this.showProgress = false
            let imgBlockFields = this.getBlockFields(blockId)
            /**
             * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
             */
            let clonedBlockFieldsData = { ...imgBlockFields.data }
            clonedBlockFieldsData.src = res
            imgBlockFields.data = clonedBlockFieldsData
          },
          (err) => {
            this.showProgress = false
            alert('error uploading file, please contact support')
          }
        )
      })

      reader.readAsDataURL(file)
    }
  }
  /**
   * get all the image block fields from the service and adjust the src only
   * @param $event change event on the input field
   */
  imgSrcChange($event: any, blockId: any) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
  }

  styleChange(style: any, blockId: any, $event: any, type: string, index: 0) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let textBlockFields = this.getBlockFields(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...textBlockFields.style }
    let data = ''
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value
    } else if (type == 'slider') {
      data = $event.value + 'px'
    }

    clonedBlockFieldsData[style] = data
    textBlockFields.style = clonedBlockFieldsData
  }

  getBlockFields = (id: string) => {
    // For website builder, return the blockFields directly (loaded from static blocks)
    if (this.builderType === 'website' && this.blockFields) {
      return this.blockFields
    }

    // For mobile builder, use existing logic
    if (!this.builderService.globals && !this.blockFieldsService.readGlobalFooter) {
      return this.getBlockFieldsCustomPage(id)
    }
    if (this.builderService.globalFooter == undefined) {
      this.builderService.globalFooter = this.blockDataService.tempFooter
    }
    // if(this.builderService.globalFooter && this.builderService.globalFooter?.data?.global_footer == this.builderService.globalFooter?.global_footer ) {
    //   const data = { ...this.builderService.globalFooter };
    //   delete data.data;
    //   this.builderService.globalFooter.data = data;
    // }
    return this.builderService.globalFooter
  }

  getBlockFieldsCustomPage = (id: string) => {
    if (this.importedBlockData) {
      return this.importedBlockData
    }
    if (!this.blockDataService.blocksData) {
      return false
    }
    return this.blockDataService.getSelectedBlockData(id)
  }

  // ── Floating Social helpers ──────────────────────────────────────────────

  getPlatformIcon(platform: string): SafeHtml {
    return this.floatingSocialService.getPlatformIcon(platform)
  }

  getPlatformColor(platform: string): string {
    return this.floatingSocialService.getPlatformColor(platform)
  }

  getPlatformLabel(platform: string): string {
    return this.floatingSocialService.getPlatformLabel(platform)
  }

  getFloatingSocial(blockId: string) {
    const fields = this.getBlockFields(blockId)
    if (!fields?.data?.floatingSocial) {
      if (fields?.data) {
        fields.data.floatingSocial = {
          enabled: false,
          socials: [{ platform: 'whatsapp', url: '' }],
          style: { 'background-color': '#567EDC', 'position-x': 'right' }
        }
      }
    }
    return fields?.data?.floatingSocial
  }

  toggleFooterSocial(blockId: string, $event: any) {
    const fields = this.getBlockFields(blockId)
    const cloned = { ...fields.data }
    cloned.floatingSocial = { ...this.getFloatingSocial(blockId), enabled: $event.checked }
    fields.data = cloned
    if (this.builderType === 'website') this.saveStaticFooter()
  }

  addFooterSocial(blockId: string) {
    const fields = this.getBlockFields(blockId)
    const cloned = { ...fields.data }
    const clonedSocial = { ...cloned.floatingSocial }
    clonedSocial.socials = [...(clonedSocial.socials || []), { platform: 'whatsapp', url: '' }]
    cloned.floatingSocial = clonedSocial
    fields.data = cloned
    if (this.builderType === 'website') this.saveStaticFooter()
  }

  removeFooterSocial(blockId: string, index: number) {
    const fields = this.getBlockFields(blockId)
    const cloned = { ...fields.data }
    const clonedSocial = { ...cloned.floatingSocial }
    clonedSocial.socials = [...(clonedSocial.socials || [])]
    clonedSocial.socials.splice(index, 1)
    cloned.floatingSocial = clonedSocial
    fields.data = cloned
    if (this.builderType === 'website') this.saveStaticFooter()
  }

  footerSocialPlatformChange(blockId: string, index: number, $event: any) {
    const fields = this.getBlockFields(blockId)
    const cloned = { ...fields.data }
    const clonedSocial = { ...cloned.floatingSocial }
    clonedSocial.socials = clonedSocial.socials.map((s: any) => ({ ...s }))
    clonedSocial.socials[index].platform = $event.value
    cloned.floatingSocial = clonedSocial
    fields.data = cloned
    if (this.builderType === 'website') this.saveStaticFooter()
  }

  footerSocialUrlChange(blockId: string, index: number, $event: any) {
    const fields = this.getBlockFields(blockId)
    const cloned = { ...fields.data }
    const clonedSocial = { ...cloned.floatingSocial }
    clonedSocial.socials = clonedSocial.socials.map((s: any) => ({ ...s }))
    clonedSocial.socials[index].url = $event.currentTarget.value
    cloned.floatingSocial = clonedSocial
    fields.data = cloned
    if (this.builderType === 'website') this.saveStaticFooter()
  }

  footerSocialStyleChange(style: string, blockId: string, $event: any, type: string) {
    const fields = this.getBlockFields(blockId)
    const cloned = { ...fields.data }
    const clonedSocial = { ...cloned.floatingSocial }
    clonedSocial.style = { ...clonedSocial.style, [style]: type === 'select' ? $event.value : $event.currentTarget.value }
    cloned.floatingSocial = clonedSocial
    fields.data = cloned
    if (this.builderType === 'website') this.saveStaticFooter()
  }

  uploadSocialImage(blockId: string, index: number, event: any) {
    const file: File = event.target.files?.[0]
    if (!file) return
    const path = `images/${file.name}`
    this.storageService.uploadFile(file, this.builderService.selectedProject, path).then((downloadURL: string) => {
      const fields = this.getBlockFields(blockId)
      const cloned = { ...fields.data }
      const clonedSocial = { ...cloned.floatingSocial }
      clonedSocial.socials = clonedSocial.socials.map((s: any) => ({ ...s }))
      clonedSocial.socials[index].image = downloadURL
      cloned.floatingSocial = clonedSocial
      fields.data = cloned
      if (this.builderType === 'website') this.saveStaticFooter()
    })
  }

  showStyleTab = () => {
    this.previewBlock = false
    this.previewFields = false
    this.styleFields = true
  }

  showDataTab = () => {
    this.previewBlock = false
    this.previewFields = true
    this.styleFields = false
  }

  checkSidebar = () => {
    if (!this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkPreview = () => {
    if (this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkData = () => {
    if (this.previewFields) {
      return true
    }
    return false
  }

  checkStyle = () => {
    if (this.styleFields && !this.previewFields && !this.previewBlock) {
      return true
    }
    return false
  }

  checkSettings = () => {
    if (!this.checkSidebar() && !this.checkPreview()) {
      return true
    }
    return false
  }

  addMenuItem = (blockId: string) => {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let footerBlockFields = this.getBlockFields(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...footerBlockFields.data }
    console.log(clonedBlockFieldsData)
    let data: any = ''
    if (!clonedBlockFieldsData.menuItems) {
      clonedBlockFieldsData = {
        menuItems: [
          {
            index: 0,
            icon: 'home',
            color: '#000000',
            link: 'home',
            menuText: 'Home'
          }
        ]
      }
    } else {
      clonedBlockFieldsData.menuItems.push({
        index: clonedBlockFieldsData.menuItems.length,
        icon: 'home',
        color: '#000000',
        link: 'home',
        menuText: 'Home'
      })
    }
    footerBlockFields.data = clonedBlockFieldsData
    this.builderService.globalFooter = footerBlockFields
  }

  addGBannerItem = (blockId: string) => {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let footerBlockFields = this.getBlockFields(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...footerBlockFields.data }
    let data: any = ''
    if (!clonedBlockFieldsData.gFooterBanners) {
      clonedBlockFieldsData['gFooterBanners'] = [
        {
          index: 0,
          status: 'inactive',
          bannerAdId: '',
          gFooterBannerPage: 'Home'
        }
      ]
    } else {
      clonedBlockFieldsData.gFooterBanners.push({
        index: clonedBlockFieldsData.gFooterBanners.length,
        status: 'inactive',
        bannerAdId: '',
        gFooterBannerPage: 'home'
      })
    }
    footerBlockFields.data = clonedBlockFieldsData
  }

  selectIconDialog = (blockId: string, menuIndex: any) => {
    const dialogRef = this.dialog.open(IconsSelectorComponent, {
      width: '1000px',
      height: '650px',
      maxWidth: '100%'
    })
    dialogRef.afterClosed().subscribe(() => {
      let menuItemsBlockFields = this.getBlockFields(blockId)
      for (let index = 0; index < menuItemsBlockFields.data.menuItems.length; index++) {
        const element = menuItemsBlockFields.data.menuItems[index]
        if (element.index == menuIndex) {
          menuItemsBlockFields.data.menuItems[menuIndex].icon = this.builderService.selectedIcon
          this.builderService.globalFooter.data.menuItems[menuIndex].icon = this.builderService.selectedIcon
        }
      }
    })
  }

  getCategories = (projectId: number, args: object, cached = true) => {
    this.showProgress = true
    if (cached) {
      this.categoriesService.getCategoriesCached().subscribe(
        (response) => {
          let categories: any = []
          for (const key in response) {
            if (Object.prototype.hasOwnProperty.call(response, key)) {
              const element = response[key]
              if (element.count > 0) {
                categories.push({ id: element.term_id, name: element.name, thumbnail: element.image_url })
              }
            }
          }
          this.showProgress = false
          this.categoriesService.storedCategories = categories
        },
        (err) => {}
      )
    } else {
      this.categoriesService.getCategories(projectId, args).subscribe(
        (response) => {
          let categories: any = []
          for (const key in response) {
            if (Object.prototype.hasOwnProperty.call(response, key)) {
              const element = response[key]
              if (element.count > 0) {
                categories.push({ id: element.term_id, name: element.name, thumbnail: element.image_url })
              }
            }
          }
          this.showProgress = false
          this.categoriesService.storedCategories = categories
        },
        (err) => {}
      )
    }

    return true
  }

  getPosts = (projectId: number, args: object, cached = true) => {
    this.showProgress = true
    if (cached) {
      this.postsService.getPostsCached().subscribe(
        (response) => {
          this.showProgress = false
          let posts: any = []
          for (const key in response) {
            if (Object.prototype.hasOwnProperty.call(response, key)) {
              const element = response[key]
              if (element) {
                posts.push({ ID: element.ID, post_title: element.post_title, post_image: element.post_image })
              }
            }
          }
          this.storedPosts = posts
        },
        (err) => {}
      )
    } else {
      this.postsService.getPosts(projectId, args).subscribe(
        (response) => {
          this.showProgress = false
          let posts: any = []
          for (const key in response) {
            if (Object.prototype.hasOwnProperty.call(response, key)) {
              const element = response[key]
              if (element) {
                posts.push({ ID: element.ID, post_title: element.post_title, post_image: element.post_image })
              }
            }
          }
          this.storedPosts = posts
        },
        (err) => {}
      )
    }

    return true
  }

  getProducts = (projectId: number, args: object, cached = true) => {
    this.showProgress = true
    if (cached) {
      this.productsService.getProductsCached().subscribe(
        (response) => {
          this.showProgress = false
          let products: any = []
          let responseProducts = response.products
          for (const key in responseProducts) {
            if (Object.prototype.hasOwnProperty.call(responseProducts, key)) {
              const element = responseProducts[key]
              if (element) {
                products.push({ id: element.id, name: element.name })
              }
            }
          }
          this.storedProducts = products
        },
        (err) => {}
      )
    } else {
      this.productsService.getProducts(projectId, args).subscribe(
        (response) => {
          this.showProgress = false
          let products: any = []
          let responseProducts = response.products
          for (const key in responseProducts) {
            if (Object.prototype.hasOwnProperty.call(responseProducts, key)) {
              const element = responseProducts[key]
              if (element) {
                products.push({ id: element.id, name: element.name })
              }
            }
          }
          this.storedProducts = products
        },
        (err) => {}
      )
    }

    return true
  }

  getStandaloneCategories = () => {
    this.standaloneCategoriesService.getCategories().subscribe((response: any) => {
      let categories: any = []
      for (const key in response) {
        if (Object.prototype.hasOwnProperty.call(response, key)) {
          const element = response[key]
          categories.push({ id: element.categoryId, name: element.categoryName, thumbnail: element.categoryImage, subcategories: element.subcategories })
        }
      }
      this.standaloneCategoriesService.storedStandaloneCategories = categories
    })
  }

  setSelectedSubCategory(subCategoryId: any) {
    const existingSubCategory = this.standaloneCategoriesService.availableSubs.find((sub: any) => sub.subCategoryId === subCategoryId)

    if (existingSubCategory) {
      this.blockData.data.subcategories = existingSubCategory.subCategoryId
    }
  }
  getStandaloneSubCats = (selectedCat: any) => {
    this.standaloneCategoriesService.availableSubs = []
    if (selectedCat?.subcategories) {
      for (let sub of selectedCat?.subcategories) {
        this.standaloneCategoriesService.availableSubs.push(sub)
      }
      if (this.getBlockFields(this.blockId).data.subcategories) {
        this.setSelectedSubCategory(this.getBlockFields(this.blockId).data.subcategories)
      }
    }
  }

  getCat(catId: any) {
    this.standaloneCategoriesService.getCategory(catId.value).subscribe((cat) => {
      this.getStandaloneSubCats(cat)
    })
    if (this.getBlockFields(this.blockId).data.subcategories) {
      this.setSelectedSubCategory(this.getBlockFields(this.blockId).data.subcategories)
    }
  }
  deleteMenuItem = (blockId: string, menuIndex: number) => {
    let menuItemsBlockFields = this.getBlockFields(blockId)
    menuItemsBlockFields.data.menuItems.splice(menuIndex, 1)
    this.reindexMenuItems(blockId)
  }

  deleteGBannerItem = (blockId: string, gFooterBannerIndex: number) => {
    let menuItemsBlockFields = this.getBlockFields(blockId)
    menuItemsBlockFields.data.gFooterBanners.splice(gFooterBannerIndex, 1)
    this.reindexMenuItems(blockId)
  }

  reindexMenuItems = (blockId: string) => {
    let menuItemsBlockFields = this.getBlockFields(blockId)
    for (let i = 0; i < menuItemsBlockFields.data.menuItems.length; i++) {
      menuItemsBlockFields.data.menuItems[i].index = i
    }
  }

  /**
   * Add a new footer link (product or company link)
   */
  addFooterLink = (blockId: string, linkType: 'productLinks' | 'companyLinks') => {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let footerBlockFields = this.getBlockFields(blockId)
    let clonedBlockFieldsData = { ...footerBlockFields.data }

    if (!clonedBlockFieldsData[linkType]) {
      clonedBlockFieldsData[linkType] = []
    }

    // Use first available page or default to home
    const defaultUrl = this.availablePages.length > 0 ? '/' + this.availablePages[0].name : '/home'

    clonedBlockFieldsData[linkType].push({
      name: linkType === 'productLinks' ? 'New Product' : 'New Page',
      url: defaultUrl
    })

    footerBlockFields.data = clonedBlockFieldsData

    // Save for website builder
    if (this.builderType === 'website') {
      this.saveStaticFooter()
    }
  }

  /**
   * Remove footer background image
   */
  removeFooterBgImage = (blockId: string) => {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let footerBlockFields = this.getBlockFields(blockId)
    let clonedBlockFieldsData = { ...footerBlockFields.data }

    delete clonedBlockFieldsData.footerBgImageUrl
    footerBlockFields.data = clonedBlockFieldsData

    // Save for website builder
    if (this.builderType === 'website') {
      this.saveStaticFooter()
    }
  }

  /**
   * Delete a footer link
   */
  deleteFooterLink = (blockId: string, linkIndex: number, linkType: 'productLinks' | 'companyLinks') => {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let footerBlockFields = this.getBlockFields(blockId)
    let clonedBlockFieldsData = { ...footerBlockFields.data }

    if (clonedBlockFieldsData[linkType] && clonedBlockFieldsData[linkType].length > linkIndex) {
      clonedBlockFieldsData[linkType].splice(linkIndex, 1)
    }

    footerBlockFields.data = clonedBlockFieldsData

    // Save for website builder
    if (this.builderType === 'website') {
      this.saveStaticFooter()
    }
  }

  /**
   * Select a footer template (website builder only)
   * Merges template config into footer data and saves to Firebase
   */
  selectFooterTemplate = (blockId: string, templateId: string) => {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }

    let footerBlockFields = this.getBlockFields(blockId)
    let clonedBlockFieldsData = { ...footerBlockFields.data }

    // Get template config from local styles
    const templateConfig = (footerTemplatesStyle as any)[templateId]

    // Merge template config into footer data
    clonedBlockFieldsData['footerTemplate'] = templateId
    if (templateConfig) {
    clonedBlockFieldsData['hasWave'] = templateConfig.hasWave
    clonedBlockFieldsData['footerStyle'] = templateConfig.footerStyle
    clonedBlockFieldsData['layout'] = templateConfig.layout
    clonedBlockFieldsData['styleVars'] = templateConfig.styleVars
    clonedBlockFieldsData['wave'] = templateConfig.wave || null
    clonedBlockFieldsData['footerBgImageUrl'] = templateConfig.footerBgImageUrl || null  
    clonedBlockFieldsData['showFloatingBar'] = templateConfig.showFloatingBar || null       
    }

    footerBlockFields.data = clonedBlockFieldsData

    // Save for website builder
    if (this.builderType === 'website') {
      this.saveStaticFooter()
    }
  }
}
